import dayjs from 'dayjs';
import { Row, Form } from 'react-bootstrap';
import Select from 'react-select';

import { customStyles } from '../utils';

import './styles.scoped.css';

// Secure Act 2.0 reporting begins with 2024 and adds each year going forward.
const FIRST_YEAR = 2024;

const getYearOptions = () => {
  const currentYear = dayjs().year();
  const options = [];
  for (let year = currentYear; year >= FIRST_YEAR; year -= 1) {
    options.push({ label: year.toString(), value: year.toString() });
  }
  return options;
};

export const FicaIndicatorForm = ({ form, setForm }) => {
  const yearOptions = getYearOptions();
  return (
    <div className="filters-container">
      <span>
        This report will return the FICA wages for the year indicated for all active Drivers.
        <br />
        Select the year that the data is needed for.
      </span>
      <div className="filter-row" style={{ marginTop: '30px' }}>
        <Form.Group as={Row} controlId="Year" style={{ alignItems: 'center' }}>
          <Form.Label style={{ width: '220px' }}>
            <div className="required">Select the Look Back Year</div>
          </Form.Label>
          <Select
            styles={customStyles('150px')}
            options={yearOptions}
            value={yearOptions.find(option => option.value === form?.Year) || null}
            onChange={selectedOption => setForm({ ...form, Year: selectedOption?.value })}
          />
        </Form.Group>
      </div>
    </div>
  );
};
